import styled from "styled-components";
import { CiClock2 } from "react-icons/ci";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import {Link, useNavigate} from "react-router";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex-basis: 31%;
  cursor: pointer;
`
const Img = styled.img``;
const TimeToRead = styled.p`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
`;
const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
`;
const ReadNow = styled(Link)`
  margin-top: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
  color: #6f1d39;
`;

function ArticleTile({ image, title, timeToRead, url }) {
    const navigate = useNavigate();

    return <Container onClick={() => navigate(url)}>
        <Img src={image} />
        <TimeToRead>
            <CiClock2 color="#09090B" size={24} />
            <span>{timeToRead} min. czytania</span>
        </TimeToRead>
        <Title>{title}</Title>
        <ReadNow to={url}>
            <span>Czytaj teraz</span>
            <MdOutlineKeyboardArrowRight size={16} />
        </ReadNow>
    </Container>
}

export default ArticleTile;
